import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { UserDto } from 'src/app/core/model/user.model';
import { ReturnUrlService } from '../return-url/return-url.service';
import { environment } from 'src/environments/environment';
import { InvitedUser } from 'src/app/core/interfaces/user.interface';
import {
  AUTHORIZATION_HEADER,
  INV_TOKEN,
  TOKEN,
  DOMAIN_PREFIX,
} from 'src/app/core/constants/auth.constants';
import { CompanyService } from '../company/company.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private http = inject(HttpClient);

  private returnUrlService = inject(ReturnUrlService);

  private location = inject(DOCUMENT).location;

  private companyService = inject(CompanyService);

  #jwtToken: string | undefined | null;

  login(user: UserDto): Observable<any> {
    return this.http
      .post(
        environment.apiUrl(this.companyService.name),
        user,
        { observe: 'response' }
      )
      .pipe(
        tap((response) => {
          this.#jwtToken = response.headers.get(AUTHORIZATION_HEADER);
          if (this.#jwtToken) {
            this.redirectUserByReturnUrl();
          }
        }),
        catchError((error) => {
          console.error(error);
          return of(error);
        })
      );
  }

  register(form: InvitedUser) {
    const companyName = this.companyService.name;
    const invitationToken = this.getSearchParam(INV_TOKEN);

    return this.http
      .put(environment.invitationApiUrl(companyName), {
        password: form.password,
        password_confirmation: form.confirmPassword,
        invitation_token: invitationToken,
      })
      .pipe(
        tap(() => this.location.replace(`${DOMAIN_PREFIX}.${companyName}.${environment.baseDomain}`)),
        catchError((error) => {
          console.error(error);
          return of(error);
        })
      );
  }

  redirectUserByReturnUrl(): void {
    const url = new URL(this.returnUrlService.returnUrl);
    url.searchParams.set(TOKEN, this.#jwtToken as string);
    this.location.replace(url);
  }

  private getSearchParam(param: typeof INV_TOKEN) {
    return (
      new URLSearchParams(new URL(window.location.href).search).get(param) || ''
    );
  }
}
